<template>
    <div class="context-menu"
         v-show="show"
         :style="style"
         ref="context"
         tabindex="0"
         @blur="closeMenu">

        <div class="block">
            <p style="display:flex; flex-direction:row; margin-bottom: 1em;"
               @click="pushConversationLink">
                <b-icon icon="calendar-edit"
                        custom-class="mdi-calendar-edit"
                        size="is-medium" />
                <span style="font-size: large; margin-left: 1em;">
                    {{ userType | capitalize }} conversations</span>
            </p>
        </div>

    </div>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'ConversationsContextMenu',
    props: {
        display: Boolean, // prop detect if we should show context menu
        conversationId: String, // prop to add to router link
        userType: String,
        userId: String
    },
    data() {
        return {
            left: 0, // left position
            top: 0, // top position
            show: false, // affect display of context menu
        };
    },
    computed: {
        // get position of context menu
        style() {
            return {
                top: `${this.top}px`,
                left: `${this.left}px`,
            };
        },
    },
    methods: {
        pushConversationLink() {
            // alert(this.conversationId); // !!
            // this.$router.push({ name: 'conversations.conversation', params: { id: this.conversationId } });
            this.$router.push({ name: 'conversations.employee', params: { id: this.conversationId, userId: this.userId } });
        },
        // closes context menu 
        closeMenu() {
            this.show = false;
            this.left = 0;
            this.top = 0;
        },
        openMenu(evt) {
            // Since we are only listening to right click event on first column, we can use eith pageX or clientX.
            // If we choose to listen on whole row, we should use pageX to get position of mouse relative to document

            // updates position of context menu 
            this.left = evt.pageX || evt.clientX;
            this.top = evt.clientY;

            // make element focused 
            // @ts-ignore
            Vue.nextTick(() => {
                this.$el.focus();
            });

            this.show = true;
        }
    },
    filters: {
        capitalize(value) {
            if (!value) return ''
            const value2 = value.toString()
            return value2.charAt(0).toUpperCase() + value2.slice(1)
        }
    }
};
</script>

<style scoped>
.context-menu {
    position: fixed;
    background: white;
    z-index: 999;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    background-color: white;
    border: 1px solid #ccc;
    padding: 1rem;
    border-radius: 0.5rem;

}
</style>



// WEBPACK FOOTER //
// src/taskflex/administration/components/projects/ConversationsContextMenu.vue